
import { Axios } from "./axios.interceptor";
// import { useState } from "react";
// import { useSelector } from "react-redux";
// import { store } from './redux/store';
// export const token = useSelector((item)=>item.user.user.token) 
//   const token = store?.getState()?.user?.user?.token;
// const data=localStorage.getItem("bsuser")
// const parsedData = JSON.parse(data);
// const token = parsedData?.token; 


/******************************************************** BellIcon Notification      ******************************** */
export const bellIconNotificationApi=({token,currentPage})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/get-notifications?page=${currentPage}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response.data);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const readNotifcationApi=({token})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/update-notifications`,{
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}



/*****************************************************Signup and Forget*********************************** */
export const handleSignUp = ({credentials,tok}) => {

    
    return new Promise(async (resolve, reject) => {
        try {
            const response = await Axios.post(
                "api/v1/admin/login",
                {
                    email: credentials.email,
                    password: credentials.password,
                    fcmToken:tok
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            resolve(response);
        } catch (error) {
                console.log("err",error);
                
            reject(error.response);
        }
    });
};


export const handleForgetApi = (email) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await Axios.post(
                "api/v1/admin/forget-password",
                {
                    email
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    });
};


export const handleOtpApi = ({ refId, otp }) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await Axios.post(
                "api/v1/admin/verify-otp",
                {
                    refId, otp
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    });
};


export const handleResendOtpApi = (refId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await Axios.post(
                "api/v1/admin/resend-otp",
                {
                    refId
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    });
};

export const handleChangePassApi = ({refId,newPassword}) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await Axios.post(
                "api/v1/admin/reset-password",
                {
                    refId,newPassword
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    });
};
/******************************************************* Dashoboard apis ***************************************************/

export const dashboardDataApi=({token,filter})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/get-total-data?filter=${filter}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response.data);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}



/******************************************************* User/Sub Admin Permission *********************************/








export const allSubAdminApi=({token,currentPage})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/get-sub-admins?page=${currentPage}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const createNewSubAdmin=({token,newAdminData })=>{
    // console.log("apis",forumData);
    // console.log("Sending newAdminData to API:", newAdminData);
    
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.post(
                `api/v1/admin/create-sub-admin`,
                {
                        username: newAdminData.username,
                        email: newAdminData.email,
                        phone: newAdminData.phone,
                        password: newAdminData.password,
                        retypePassword: newAdminData.retypePassword,
                        permissions: newAdminData.permissions, 
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const deleteSubAdmin=({token,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.delete(
                `api/v1/admin/delete-sub-admin/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const updateSubAdmin=({token,id,editedValue})=>{
    // console.log("apis",forumData);
    
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/update-sub-admin/${id}`,editedValue,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}


export const blockUnblockSubAdmin=({token,id,lock})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.patch(
                `api/v1/admin/lock-unlock/${id}`,{lock:lock},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const subAdminByIdApi=({token,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/get-sub-admin/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}










/******************************************************* Manage Profile ***************************************************/
export const updateProfileDataApi=({token,user})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const formData = new FormData();
            formData.append("firstName", user.firstName);
            formData.append("lastName", user.lastName);
            formData.append("phone", user.phoneNo);
            if (typeof user.picture == "object" && user.picture != "") {
                formData.append("picture", user.picture);
            }
            const response = await Axios.put(
                `api/v1/admin/edit-profile`,formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const updatePasswordApi= async ({ allPass, token }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.post(
          `api/v1/admin/edit-password`,
          {
            currentPassword: allPass.currentPassword,
            newPassword: allPass.newPassword,
            cPassword: allPass.cPassword,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
  
        resolve(response);
      } catch (error) {
        console.error("Error updating user:", error);
        reject(error);
      }
    });
  };






/*******************************************************UserManangemnet / Contact Us Landing page data********************/


export const handleContactedPersonApi=({token,currentPage})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/get-contact-us?page=${currentPage}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}


export const allUserListApi=({token,type,currentPage,searchQuery=""})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/user?type=${type}&&page=${currentPage}&search=${searchQuery}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response.data);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const allOrderListApi=({token,id,currentPage,searchQuery})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/order/${id}?page=${currentPage}&&search=${searchQuery}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response.data);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const OrderDetailsApi=({token,id})=>{
   
    
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/orderDetail/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response.data);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const allResourcesListApi=({token,currentPage,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/resources/${id}?page=${currentPage}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response.data);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}


export const allForumListApi=({token,id,currentPage})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/joinedForums/${id}?page=${currentPage}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const allUserPostListApi=({token,currentPage,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/posts/${id}?page=${currentPage}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response.data);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

// used for delete , block , update this same api
export const updateUserApi=({token,id,account_status})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/managment/update-user/${id}`,{account_status},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

// resource publish and unblish and delete api
export const resourcBlockApi=({token,id,status})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/managment/resource-status/${id}`,{status},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

// delte post api
export const postDeleteApi=({token,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.delete(
                `api/v1/admin/managment/post-delete/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}


export const allUserCommentsDataApi=({token,id,commentCurrentPage})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/post-comment/${id}?page=${commentCurrentPage}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response.data);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}





/**************************************************  Vender Management **********************************************/


export const allPendingVenderApi=({token,currentPage})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/pending-vendor?page=${currentPage}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response.data);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}


export const rejectVenderApi=({token,id,vendorStatus,rejectReason})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/managment/vendor-status/${id}`,{vendorStatus,rejectReason},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}


export const acceptVenderApi=({token,id,vendorStatus})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/managment/vendor-status/${id}`,{vendorStatus},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const blockVenderApi=({token,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/managment/block-vendor/${id}`,{},
                {
                    headers: {
                        Authorization:`Bearer ${token}`,
                        "Content-Type":"application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
         
            reject(error);
        }
    })
}

export const resumeVenderApi=({token,id})=>{  
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/managment/resume-vendor/${id}`,{},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error);
        }
    })
}

export const deleteVenderApi=({token,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.delete(
                `api/v1/admin/managment/delete-vendor/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error.response);
        }
    })
}

// ***********************************************************Vendor Products apis *****************************


export const allVendorProductsApi=({token,currentPage,searchQuery,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/vendor-products/${id}?page=${currentPage}&&search=${searchQuery}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response.data);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const venderProductDetailApi=({token,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/product-detail/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response.data);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const deleteProductApi=({token,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.delete(
                `api/v1/admin/managment/delete-product/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}


// all pending products,
export const allPendingProductsApi=({token,currentPage,searchQuery,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/pending-products/${id}?page=${currentPage}&&search=${searchQuery}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response.data);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

 // ENUM : status:['active','rejected']

// reject prodcuts
export const rejectProductApi=({token,id,status,reject_reason})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/managment/product-status/${id}`,{status,reject_reason},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

// aceept prodcuts
export const acceptProductApi=({token,id,status})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/managment/product-status/${id}`,{status},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}


// getv all events 
export const allVenderEventsApi=({token,currentPage,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/vendor-events/${id}?page=${currentPage}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}
// block vender events
export const blockVenderEventApi=({token,id,})=>{
    // console.log("gh",id);
    
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/managment/block-event/${id}`,{},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

// resume evnt
export const resumeVenderEventApi=({token,id,})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/managment/resume-event/${id}`,{},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}
// delete
export const deleteVenderEventApi=({token,id,})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.delete(
                `api/v1/admin/managment/delete-event/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}



//*********************************************************** All Orders Maganement***********************************/

export const allOrderManagementApi=({token,currentPage,searchQuery})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/total-orders?page=${currentPage}&&search=${searchQuery}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const orderStatusApi=({token,id,status})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/managment/order-status/${id}`,{status},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}
// orderdtail api i have use which i have used during product details
// export const allOrderManagementProductsApi=({token,currentPage,searchQuery})=>{
//     return new Promise (async(resolve,reject)=>{
//         try {  
//             const response = await Axios.get(
//                 `api/v1/admin/managment/orderDetail/?page=${currentPage}&&search=${searchQuery}`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": "application/json",
//                     },
//                 }   
//             );
//             resolve(response);
//         } catch (error) {
//             reject(error?.response?.data || error);
//         }
//     })
// }



//*********************************************************** Content Moderation sidebar***********************************/
export const getAllContentModerationForum=({token,currentPage,})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/forum?page=${currentPage}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                       "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const createForumApi=({token,forumData})=>{
    // console.log("apis",forumData);
    
    return new Promise (async(resolve,reject)=>{
        try {  
            const formData = new FormData();
            formData.append("title", forumData.title);
            formData.append("description", forumData.description);
            if (typeof forumData.picture == "object" && forumData.picture != "") {
                formData.append("picture", forumData.picture);
            }
            const response = await Axios.post(
                `api/v1/admin/managment/forum`,formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const updateFourmApi=({token,id,forumData})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const formData = new FormData();
            formData.append("title", forumData.title);
            formData.append("description", forumData.description);
            if (typeof forumData.picture == "object" && forumData.picture != "") {
                formData.append("picture", forumData.picture);
            }
            const response = await Axios.put(
                `api/v1/admin/managment/edit-forum/${id}`,formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const deleteForumApi=({token,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.delete(
                `api/v1/admin/managment/delete-forum/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}
export const getAllModerationForumPost=({token,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/forum-detail/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                       "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

//  for delte forum post i am using same api as revious user post
// export const deleteForumPostApi=({token,id})=>{
//     return new Promise (async(resolve,reject)=>{post
//         try {  
//             const response = await Axios.delete(
//                 `api/v1/admin/managment/delete-forum//${id}`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": "application/json",
//                     },
//                 }   
//             );
//             resolve(response);
//         } catch (error) {
//             reject(error?.response?.data || error);
//         }
//     })
// }




//*********************************************************** Repory and analysis sidebar***********************************/
export const getPopularProductApi=({token,currentPage,limit})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/get-popular-products?page=${currentPage}&limit=${limit}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                       "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}



//*********************************************************** Event Maganement sidebar***********************************/
// get all events sidebar tab
export const getAllEventsApi=({token,currentPage,})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/managment/events?page=${currentPage}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                       "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const unpublishEventApi=({token,id,})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/managment/unpublish-event/${id}`,{},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

// ******************************************************** Push Notification *****************************************

export const getAllNotificationApi=({token,currentPage,})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/get-all-push-notification?page=${currentPage}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                       "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}


export const createNotificationApi=({token,formData})=>{
    // console.log("apis",forumData);
    
    return new Promise (async(resolve,reject)=>{
        try {  
            // const formData = new FormData();
            // formData.append("title", forumData.title);
            // formData.append("description", forumData.description);
            // if (typeof forumData.picture == "object" && forumData.picture != "") {
            //     formData.append("picture", forumData.picture);
            // }
            const response = await Axios.post(
                `api/v1/admin/create-push-notification`,formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const updateNotification=({token,id,formData})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/update-push-notification/${id}`,formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}



export const deleteNotification=({token,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.delete(
                `api/v1/admin/delete-push-notification/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const notificationByIdApi=({token,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/get-push-notification/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                       "Content-Type": "application/json",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

// ******************************************************** Chat and Support*****************************************
export const getAllTIcketList=({token,status,currentPage,limit})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/support/?status=${status}&&page=${currentPage}&&limit=${limit}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const getMessageApi=({token,id})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.get(
                `api/v1/admin/support-conversation/${id}?limit=30`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }   
            );
            resolve(response.data);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}

export const ticketStatusApi=({token,id,status})=>{
    return new Promise (async(resolve,reject)=>{
        try {  
            const response = await Axios.put(
                `api/v1/admin/support-status/${id}`,{status},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }   
            );
            resolve(response);
        } catch (error) {
            console.log("erre",error);
            
            reject(error?.response?.data || error);
        }
    })
}


export const sendMsgApi=({token,message,id})=>{
    // console.log("apis",forumData);

    return new Promise (async(resolve,reject)=>{
        try {
            // const formData = new FormData();
            // formData.append("title", forumData.title);
            // formData.append("description", forumData.description);
            // if (typeof forumData.picture == "object" && forumData.picture != "") {
            //     formData.append("picture", forumData.picture);
            // }
            const response = await Axios.post(
                `api/v1/admin/send-message/${id}`,{message},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    })
}


/******************************************************** Feedbacks      ******************************** */
export const getFeedbackApi = ({ token, currentPage }) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await Axios.get(
                `api/v1/admin/get-feedback?page=${currentPage}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            resolve(response);
        } catch (error) {
            reject(error?.response?.data || error);
        }
    });
};


